<div class="row mb-4">
    <div class="col-sm-12 mx-auto">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <h4 class="card-title col-12 mb-4">Set CANTAB Test Backsound</h4>
                    <div class="text-center" *ngIf="!formGroup?.controls?.id">
                        <div class="spinner-grow" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                    <form *ngIf="formGroup?.controls?.id" #theForm="ngForm" (ngSubmit)="submitForm(formGroup)" novalidate class="col-12">
                        <div [formGroup]="formGroup">
                            <div class="row mb-4">
                                <div class="col-md-4">
                                    <label class="required">Upload Sound</label>
                                </div>
                                <div class="col-md-8">
                                    <div class="input-group">
                                        <input class="form-control" placeholder="Choose file" [value]="voice?.view ?? ''" readonly (click)="inputVoice.click()">
                                        <button type="button" class="btn btn-outline-primary" (click)="inputVoice.click()">
                                            <i class="material-icons">search</i>
                                        </button>
                                        <input class="d-none" #inputVoice accept=".mp3" (change)="fileHandler.handle($event, voice, 'audio/mpeg,audio/x-mpeg3,audio/mpeg3', 1)" type="file">
                                    </div>
                                    <small>FileType: mp3, size: 1MB</small>
                                </div>
                            </div>
                            <div *ngIf="currentAudio" class="row mb-4">
                                <div class="col-md-4">
                                    <label>Current backsound</label>
                                </div>
                                <div class="col-md-8">
                                    <audio controls>
                                        <source src="{{assetUrl+currentAudio}}" type="audio/mpeg">
                                        Your browser does not support the audio tag.
                                    </audio>
                                </div>
                            </div>
                            <div *ngIf="currentAudio" class="row mb-4">
                                <div class="col-md-4">
                                    <label>Status</label>
                                </div>
                                <div class="col-md-8">
                                    <div class="form-check form-switch">
                                        <input class="form-check-input" formControlName="sound_active" type="checkbox" id="status">
                                        <label class="form-check-label" for="status">{{formGroup.get('sound_active')?.value?'Active':'Inactive'}}</label>
                                    </div>
                                    <div class="text-danger" *ngIf="formGroup.get('sound_active')?.invalid && (theForm.submitted || formGroup.get('sound_active')?.touched)">
                                        <small *ngIf="formGroup.get('sound_active')?.errors?.serverError">{{formGroup.get('sound_active')?.errors?.serverError}}</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between align-items-center border-top pt-4 mt-4">
                            <div>
                                &nbsp;
                            </div>
                            <div class="text-end">
                                <button type="button" class="btn btn-secondary" (click)="back();" [attr.disabled]="loading.status ? 'disabled' : null">
                                    <i class="material-icons">close</i> &nbsp;
                                    Cancel
                                </button>
                                &nbsp;
                                <button type="submit" class="btn btn-primary" [attr.disabled]="loading.status ? 'disabled' : null">
                                    <i class="material-icons">save</i> &nbsp;
                                    Save
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
